import {createContext} from 'react'
import type {BannerProps} from '@primer/react'

/**
 * The input shape accepted by `addBanner`/`updateBanner`:
 */
export interface BannerInput extends BannerProps {
  dismissible?: boolean
}

/** A banner as tracked internally, with its generated stable `id`. */
export interface BannerData extends BannerInput {
  id: string
}

export interface InternalBannerStackDataContextValue {
  banners: BannerData[]
}

export const InternalBannerStackDataContext = createContext<InternalBannerStackDataContextValue>({
  banners: [],
})
